import { ResponsiveContext, Box, Layer, Anchor, Text, Select, Button, RadioButtonGroup } from 'grommet';
import { FormClose } from 'grommet-icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TitleSideBar, TitleField } from '../../../components';

import { closeLayer } from '../../../actions/layers';
import { searchCityOptions, searchDistrictOptions } from '../../../actions/select-options';
import { changeValues, cleanValues } from '../../../actions/form';
import { search } from '../../../actions/search';

import yearsOptions from '../../../constants/years';
import monthsOptions from '../../../constants/months';

const FormSearch = (props) => {
  if(!props.toggleLayer) return null;

  const onSearchCities = ({ text }) => {
    if (text.length < 2) return;

    const {searchCityOptions} = props;
    searchCityOptions({ name: text });
  }

  const onSearchDistricts = ({ cityId, text }) => {
    if (text.length < 2) return;

    const {searchDistrictOptions} = props;
    searchDistrictOptions({ cityId, name: text });
  }

  const onSearch = (params) => {
    const { search, closeLayer } = props;

    search({
      path: 'atendimento.estatistica.php', values: params
    });

    closeLayer();
  }

  const {
    // data
    statusOptions,
    originOptions,
    categoryOptions,
    citiesOptions,
    districtsOptions,

    // functions
    closeLayer,
    changeValues,
    cleanValues,

    // fields
    statusId,
    categoryId,
    originId,
    districtId,
    cityId,
    year,
    month,
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Layer
          responsive={false}
          full='vertical'
          position='left'
          onClickOutside={closeLayer}
          onEsc={closeLayer}
        >
          <Box
            fill='vertical'
            width='60vw'
            pad={{ top: 'large', bottom: 'xsmall' }}
            overflow='auto'
            flex
          >
            <Box
              direction='row'
              justify='between'
              margin={{ bottom: 'medium', horizontal: 'large' }}
            >
              <TitleSideBar value='Filtrar' />

              <Button
                plain
                title='Fechar'
                icon={<FormClose />}
                onClick={closeLayer}
              />
            </Box>

            {/* Campos de busca */}
            <Box flex overflow='auto'>

              { /* Ano, Mês */}
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box
                  direction='row'
                  gap='medium'
                >
                  { /* Year */}
                  <Box width='large'>
                    <Box direction='row' align='center' gap='xsmall'>
                      <TitleField text='Ano' />

                      {year && (
                        <Anchor
                          size='small'
                          label='limpar'
                          onClick={() => changeValues({ fieldName: 'year', value: null })}
                        />
                      )}
                    </Box>

                    <Select
                      options={yearsOptions}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      value={year ?? ''}
                      emptySearchMessage=''
                      onChange={({ value: nextValue }) =>
                        changeValues({ fieldName: 'year', value: nextValue })
                      }
                    />
                  </Box>

                  { /* Month */}
                  <Box width='large'>
                    <Box direction='row' align='center' gap='xsmall'>
                      <TitleField text='Mês' />

                      {month && (
                        <Anchor
                          size='small'
                          label='limpar'
                          onClick={() => changeValues({ fieldName: 'month', value: null })}
                        />
                      )}
                    </Box>

                    <Select
                      options={monthsOptions}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      value={month ?? ''}
                      emptySearchMessage=''
                      onChange={({ value: nextValue }) =>
                        changeValues({ fieldName: 'month', value: nextValue })
                      }
                    />
                  </Box>
                </Box>
              </Box>

              { /* Status */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Status' />

                  {statusId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => changeValues({ fieldName: 'statusId', value: null })}
                    />
                  )}
                </Box>

                <Box
                  pad={{ vertical: 'small' }}
                >
                  <RadioButtonGroup
                    name='statusId'
                    value={statusId ?? ''}
                    options={
                      statusOptions.map(({ id, name }) => ({
                        label: name,
                        id: `statusId_${id}`,
                        value: id.toString(),
                      }))
                    }
                    onChange={event => { changeValues({ fieldName: 'statusId', value: event.target.value }) }}
                  >
                    {(option, { checked }) => {
                      let background = null;
                      let borderColor = 'dark-5';

                      if(checked) {
                        background = 'brand';
                        borderColor = 'brand';
                      }

                      return (
                        <Box
                          direction='row'
                          gap='small'
                          justify='center'
                          align='center'
                        >
                          <Box
                            width={'20px'}
                            height={'20px'}
                            background={background}
                            round='xxsmall'
                            border={{
                              color: borderColor
                            }}
                          />
                          <Text color='dark-2' size='small'>{option.label}</Text>
                        </Box>
                      )
                    }}
                  </RadioButtonGroup>
                </Box>
              </Box>

              {/* Origem */}
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Origem' />

                  {originId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => changeValues({ fieldName: 'originId', value: null })}
                    />
                  )}
                </Box>

                <Box
                  pad={{ vertical: 'small' }}
                >
                  <RadioButtonGroup
                    name='originId'
                    value={originId ?? ''}
                    options={
                      originOptions.map(({ id, name }) => ({
                        label: name,
                        id: `originId_${id}`,
                        value: id.toString(),
                      }))
                    }
                    onChange={event => { changeValues({ fieldName: 'originId', value: event.target.value }) }}
                    wrap={true}
                    direction='row'
                  >
                    {(option, { checked }) => {
                      let background = null;
                      let borderColor = 'dark-5';

                      if(checked) {
                        background = 'brand';
                        borderColor = 'brand';
                      }

                      return (
                        <Box
                          direction='row'
                          gap='small'
                          align='center'
                          width={{ min: 'medium' }}
                          margin={{ bottom: 'small' }}
                        >
                          <Box
                            width={'20px'}
                            height={'20px'}
                            background={background}
                            round='xxsmall'
                            border={{
                              color: borderColor
                            }}
                          />
                          <Text color='dark-2' size='small'>{option.label}</Text>
                        </Box>
                      )
                    }}
                  </RadioButtonGroup>
                </Box>
              </Box>

              {/* Categoria */}
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Categoria' />

                  {categoryId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => changeValues({ fieldName: 'categoryId', value: null })}
                    />
                  )}
                </Box>

                <Box
                  pad={{ vertical: 'small' }}
                >
                  <RadioButtonGroup
                    name='categoryId'
                    value={categoryId ?? ''}
                    options={
                      categoryOptions.map(({ id, name }) => ({
                        label: name,
                        id: `categoryId_${id}`,
                        value: id.toString(),
                      }))
                    }
                    onChange={event => { changeValues({ fieldName: 'categoryId', value: event.target.value }) }}
                    wrap={true}
                    direction='row'
                  >
                    {(option, { checked }) => {
                      let background = null;
                      let borderColor = 'dark-5';

                      if(checked) {
                        background = 'brand';
                        borderColor = 'brand';
                      }

                      return (
                        <Box
                          direction='row'
                          gap='small'
                          align='center'
                          width={{ min: 'medium' }}
                          margin={{ bottom: 'small' }}
                        >
                          <Box
                            width={'20px'}
                            height={'20px'}
                            background={background}
                            round='xxsmall'
                            border={{
                              color: borderColor
                            }}
                          />
                          <Text color='dark-2' size='small'>{option.label}</Text>
                        </Box>
                      )
                    }}
                  </RadioButtonGroup>
                </Box>
              </Box>

              { /* City */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Cidade' />

                  {cityId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => {
                        changeValues({ fieldName: 'cityId', value: null });
                        changeValues({ fieldName: 'districtId', value: null });
                      }}
                    />
                  )}
                </Box>

                <Select
                  options={citiesOptions}
                  labelKey={
                    ({ name, stateAbbrev }) => (
                      <Box
                        pad={{ horizontal: 'small', vertical: 'small' }}
                        gap='xsmall'
                        direction='row'
                        align='baseline'
                      >
                        <Text size='medium' color='dark-1'>{name}</Text>
                        <Text size='small' color='dark-6'>{stateAbbrev}</Text>
                      </Box>
                    )
                  }
                  valueKey={{ key: 'id', reduce: true }}
                  value={cityId ?? ''}
                  searchPlaceholder='Digite para buscar...'
                  emptySearchMessage=''
                  onChange={({ value: nextValue }) => changeValues({ fieldName: 'cityId', value: nextValue }) }
                  onSearch={ text => onSearchCities({ text }) }
                >
                  {({ name, stateAbbrev }) => {
                    return (
                      <Box
                        pad={{ horizontal: 'small', vertical: 'small' }}
                        gap='small'
                        direction='row'
                        align='baseline'
                      >
                        <Text size='medium' color='dark-1'>{name}</Text>
                        <Text size='small' color='dark-6'>{stateAbbrev}</Text>
                      </Box>
                    )
                  }}
                </Select>
              </Box>

              { /* District */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Bairro' />

                  {districtId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => changeValues({ fieldName: 'districtId', value: null })}
                    />
                  )}
                </Box>

                <Select
                  placeholder={!cityId ? 'Selecione uma cidade antes...' : ''}
                  searchPlaceholder={cityId ? 'Digite para buscar...' : 'Selecione uma cidade antes...'}
                  emptySearchMessage={cityId ? 'Nenhum resultado encontrado.' : 'Você ainda não selecionou uma cidade...'}
                  options={districtsOptions}
                  labelKey='name'
                  valueKey={{ key: 'id', reduce: true }}
                  dropHeight='small'
                  value={districtId ?? ''}
                  onChange={({ value: nextValue }) => changeValues({ fieldName: 'districtId', value: nextValue }) }
                  onSearch={ text => onSearchDistricts({ cityId, text }) }
                  disabled={!cityId}
                />
              </Box>
            </Box>

            {/* Botões Busca/limpa */}
            <Box
              direction='row'
              pad={{ vertical: 'medium' }}
              margin={{ horizontal: 'large' }}
              justify='center'
              align='center'
              gap='small'
            >
              <Box width='small'>
                <Button
                  color='dark-3'
                  label='Limpar'
                  onClick={() => cleanValues() }
                />
              </Box>

              <Box width='small'>
                <Button
                  color='brand'
                  primary
                  label='Buscar'
                  onClick={() => onSearch({ statusId, categoryId, originId, districtId, cityId, year, month }) }
                />
              </Box>
            </Box>
          </Box>
        </Layer>
      )}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ layerReducer, queriesReducer, formReducer }) => ({
  toggleLayer: layerReducer.toggleLayer,
  statusOptions: queriesReducer.statusServiceOptions,
  originOptions: queriesReducer.originServiceOptions,
  categoryOptions: queriesReducer.categoryServiceOptions,
  citiesOptions: queriesReducer.citiesOptions,
  districtsOptions: queriesReducer.districtsOptions,

  statusId: formReducer.statusId,
  categoryId: formReducer.categoryId,
  originId: formReducer.originId,
  districtId: formReducer.districtId,
  cityId: formReducer.cityId,
  year: formReducer.year,
  month: formReducer.month,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    closeLayer,
    searchCityOptions,
    searchDistrictOptions,
    changeValues,
    cleanValues,
    search,
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FormSearch);
